<template>
  <div>
    <!--     Modal for download pdf tasks-->
    <download-modal :selectedTasks="selectedTasks" ref="downloadPdfModal"/>

    <vue-confirm-dialog></vue-confirm-dialog>

    <top-bar :selectedTask="selectedTask"  :meta="meta" :sideBar="sideBar" :range="range"/>


    <div id="main" class="skybackground pt-0 pb-0">

      <tasks-filter-nav :sideBar="sideBar" />

      <div class="row justify-content-center">
        <div :class="{'col-md-6': detailsPage || isEdit,'col-lg-9 col-xl-8 col-md-10 col-sm-10': !detailsPage && !isEdit}" class="pr-0 pl-1" id="doctable">
          <div class="doctable">
            <div class="tableFixHead cscroll" :class="{selectionactive : selectedTasks.length}">
              <div class="search-bar pt-2 pb-1 col-md-12">
                <div class="float-left mt-1">
                  <button type="button" @click="createNewTask">
                    <img class="plus-img mb-1"  src="@/assets/images/plus.png" alt="image"> {{ $t('create_task') }}
                  </button>
                </div>
                <div class="float-right">
                  <div class="form-group doc-search mb-2">
                    <input type="text" v-model="searchString" class="form-control" placeholder="Suchen">
                    <img class="form-control-feedback search-img" src="@/assets/images/search.png" alt="img">
                  </div>
                </div>
              </div>
              <table class="table table-hover table-fixed mb-4">
                <thead>
                <tr>
                  <th class="text-center">
                    <input type="checkbox" class="master-checkbox" v-model="masterCheckbox">
                  </th>
                  <th class="pl-1">PDF</th>
                  <th>
                    {{$t("type")}}
                  </th>
                  <th>Nr</th>
                  <th>Bezeichnung</th>
                  <th>
                    {{$t("created_on")}}
                  </th>
                  <th>Fríst</th>
                  <th>{{ $t('responsible_person') }}</th>
                  <th>Status</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(doc,index) in tasks" :class="{'active-tr': selectedTask.runid === doc.runid}" :key="doc.runid" @click="setSelectedReport($event ,doc)">
                  <td class="text-center">
                    <input type="checkbox" :value="doc.pdflawid"  v-model="selectedTasks" name="checkbox" class="item-checkbox">
                  </td>
                  <td class="pl-1">
                    <img src="@/assets/images/pdf-icon.png"  alt="icon" @click="downloadOrPreviewPdf(doc.pdflawid,false)" class="pd-icon pr-2" title="Öffnen im Browser" >
                    <img src="@/assets/images/download-icon.png" @click="downloadOrPreviewPdf(doc.pdflawid,true)" alt="icon" class="pd-icon" title="PDF herunderladen">
                  </td>
                  <td>
                    <span v-if="doc.flawtype === 1">Mangel </span>
                    <span v-if="doc.flawtype === 2">Restleistung </span>
                  </td>
                  <td>{{ doc.runid}}</td>
                  <td>
                    <span v-if="detailsPage || isEdit">
                      {{doc.flawname.substring(0,30)}}<span v-if="doc.flawname.length > 30">...</span>
                    </span>
                    <span v-else>
                      {{doc.flawname.substring(0,55)}}<span v-if="doc.flawname.length > 55">...</span>
                    </span>

                  </td>
                  <td>{{ doc.flawdate | setDateFormat}}</td>
                  <td>{{ doc.fristdate | setDateFormat}}</td>
                  <td>{{ user(doc.responsibleuser) ? `${user(doc.responsibleuser).firstname} ${user(doc.responsibleuser).lastname}` : ''}}</td>
                  <td class="text-center status">
                    <i class="fa fa-circle text-success" v-if="doc.status === 0" title="Done"></i>
                    <i class="fa fa-circle text-warning" v-if="doc.status === 1" title="check"></i>
                    <i class="fa fa-circle text-danger" v-if="doc.status === 2" title="open"></i>
                    <template  v-if="usercan('editor')">
                      <img src="@/assets/images/delete_icon.png" data-value="btn" alt="remove" class="c-d-delete-icon float-right" width="21" @click="deleteDocument(doc.pdflawid,index)" title="Löschen">
                    </template>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="selectedTasks.length" class="shadow btns-bar border-top border-dark docs-pagination col-md-12 bg-white text-center position-absolute">
            <div class="pt-1 p1-0">
            <div class="col-md-12">
              <div class="row">
              <div class="col-md-4 text-left pl-0 pr-1">
                  Ausgewählte Mängel : <strong> {{selectedTasks.length}} </strong>
              </div>
                <div class="col-md-8 text-right">
                <button class="btn btn-light shadow-lg font1rem mb-1" @click="masterCheckbox = true">
                    Alle auswählen
                </button>
                  <button class="btn btn-light font1rem shadow-lg mb-1" @click="masterCheckbox = false">
                    Auswahl aufheben
                  </button>
                  <button class="btn btn-light font1rem shadow-lg mb-1 ml-2" type="button" data-toggle="modal" data-target="#pdf-modal">
                    Bericht erstellen
                  </button>
                  <button class="btn btn-light font1rem shadow-lg mb-1 ml-2" type="button" @click="makeTicket">
                    Ticket erstellen
                  </button>
                </div>
              </div>
            </div>
            </div>
          </div>
          <div class="border-top border-dark  docs-pagination col-md-12 bg-white text-center">
            <div class="pt-1 pb-0" v-if="tasks && tasks.length > 0">
              <div class="position-absolute items-count-bar">
                <span class="font-weight-normal" v-if="meta.maxcount > 20"> {{currentPage === 1 ? '1' : ((currentPage - 1) * 20)}} bis {{currentPage * 20}} von  {{meta.maxcount}} Mängel</span>
                <span class="font-weight-normal" v-else> 1 bis {{ meta.maxcount }} von  {{meta.maxcount}}  Mängel</span>
              </div>
              <sliding-pagination
                :current="currentPage"
                :total="Math.ceil(meta.maxcount / 20)"
                @page-change="pageChangeHandler"/>
            </div>
          </div>
        </div>

        <div class="col-md-6 p-0" v-if="detailsPage || isEdit">
          <!--     Tasks Preview Component -->
          <edit-task
            v-if="isEdit"
            @getTasks="refreshTasks"
            :taskPhotosParams="taskPhotosParams"
          />

          <tasks-preview v-else/>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopBar from './TasksTopBar'
import {formatDate} from '../common'
import axios from 'axios'
import SlidingPagination from 'vue-sliding-pagination'
import TasksFilterNav from './TasksFilterNav'
import TasksPreview from './TasksPreview'
import DownloadModal from  './DownloadTasksPdfModal'
import EditTask from './EditTask'
import moment from 'moment'
import {mapState} from 'vuex'
export default {
  components: { TopBar , SlidingPagination , TasksFilterNav ,TasksPreview , DownloadModal , EditTask},
  data(){
    return {
      searchString: '',
      tasks: [],
      meta: {},
      currentPage: 1,
      sideBar: false,
      selectedTasks: [],
      masterCheckbox: false,
      maintenance: true,
      selectedFlaw: {},
      checkSelectedRecord: false,
      range: [0 , 360]
    }
  },
  mounted () {
    this.getSliderInitialDates();
  },
  filters: {
    setDateFormat: (date) => formatDate(date)
  },
  methods: {

    makeTicket() {
      this.$store.state.tickets.selectedTasks = this.selectedTasks
      this.$store.state.tickets.createmode = true
      this.$router.push({name: 'Tickets', params: {id: this.$route.params.id}})
    },

    user (id) {
      return this.projectUsers.find(item => id === item.pduserid)
    },

    //Method foe delete task
     deleteDocument(id,index){
      this.$confirm({
        message: "Mangel löschen?",
        button: {
          no: 'Abbrechen',
          yes: 'Ja'
        }, callback: confirm => {
          if (confirm) {
            this.deleteDoc(id,index);
          }
        }
      });
    },

    /**Delete Document Method
     *
     */
    async deleteDoc(id,index){
      const params = this.getParams();
      this.$store.commit('loading',true)
      await this.$store.dispatch('deleteFlaw',id);
      await this.getTasks(params);
      if ((id === this.selectedFlaw.pdflawid) && (this.isEdit || this.detailsPage)){
        const select_task = this.tasks[index]
        if (select_task){
          await this.setSelectedReport({target: {}},select_task)
        }else {
          this.$store.commit('setTasksIsEdit', false)
          this.$store.commit('toggleTasksDetails', false)
          this.$store.commit('setTaskDetails', { selectedtrades: [] })
        }
      }
      this.$store.commit('loading',false)
    },

   async refreshTasks(){
      const params = this.getParams();
      await this.getTasks(params);
    },

    async getSliderInitialDates () {
      this.$store.commit('loading', true);
      let params = this.getParams();
      await this.$store.dispatch("getProjectUsers",this.$route.params.id);
      await this.$store.dispatch("getProjectServicesWithCompany",this.$route.params.id);
      await this.getTasks(params);
      let meta = this.meta
      if (meta.minimumDate){
        let dif_from = moment(meta.minimumDate);
        let dif_to = moment(meta.maximumDate);
        let d_from = moment(meta.minimumDate).format('DD.MM.YYYY');
        let d_to = moment(meta.maximumDate).format('DD.MM.YYYY');
        await this.$store.commit('setTasksMetaDateFrom', d_from)
        await this.$store.commit('setTasksMetaDateTo', d_to)
        let dif = moment.duration(dif_to.diff(dif_from)).asDays();
        this.range = [0 , dif];
        let my_range = $("#rangeSliderInTasksDocs").data("ionRangeSlider");
        setTimeout(function (){
          my_range.update({min: 0, max: dif, to: dif, from: 0});
          //refresh datepicker after set the values
          const{ 0: from,1: to } = [$("#datepicker_from"),$("#datepicker_to")]
          to.datepicker("setDate", to.val());
          from.datepicker("setDate", from.val());
          to.datepicker('refresh');
          from.datepicker('refresh');
          my_range.reset();
        });
      }
      if (this.tasks && this.tasks.length > 0){
        await this.setSelectedReport({target: 'FIRST'}, this.tasks[0]);
      }
    },


    async setSelectedReport(event, task) {
      this.$store.commit('loading', true);
      if (event.target.tagName !== 'IMG' && event.target.tagName !== 'INPUT') {
        if (this.default_params.length === 0){
          // flawId Need to be set!!!
          // await this.$store.dispatch("getTaskDetailsById",[0 , this.$route.params.id] );
        }
        this.selectedFlaw = task
        if (this.selectedTask.pdflawid != task.pdflawid){
          const new_task = await this.$store.dispatch('getTaskDetailsById', [task.pdflawid]);
          const params = new_task.flawparams.map(prm => prm.paramtitle.toLowerCase())
          const d_params = JSON.parse(JSON.stringify(this.default_params))
          d_params.forEach(itm => {
            if (!params.includes(itm.paramtitle.toLowerCase())){
              new_task.flawparams.push(itm)
            }
          });
          this.$store.commit('loading', true);
          await  this.$store.dispatch('getImagesByIdsTasksModule', this.taskPhotosParams(new_task.flawitems));
        }
        if (!this.isEdit){
          await  this.$store.commit('toggleTasksDetails', true);
        }
      }
      this.$store.commit('loading', false);
    },

    setDate:(date) => formatDate(date),

    //page changer logic is in filter component
    pageChangeHandler(page){
      this.currentPage = page
    },

    getParams(){
      let id = this.$route.params.id
      return [id, 20, 0 , null,
        [
          {
            _explicitType: "com\\projectdocu\\OrderSettingVO",
            fieldname: 'runid',
            order : 'DESC'
          }
        ],
      ]
    },

    //Get tickets list
    async getTasks(params){
      this.$store.commit('loading',true)
      await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
        {
          "methodName": "getFlawsOfProject",
          "parameters": params,
          "serviceName": "ProjectdocuService"
        },
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }).then(res => {
        if (res.statusText === "OK" || res.status === 200){
          this.tasks = res.data.flaws
          this.meta = res.data.meta
          this.checkSelectedRecord = !this.checkSelectedRecord
        }
        this.$store.commit('loading',false);
      }).catch(error=> {
        console.log(error)
        this.$store.commit('loading',false)
      })
    },

    taskPhotosParams(flawitems){
      let photo_ids = flawitems.map(item => {
        return  {
          "fieldname": "pdphotoid",
          "fieldvalue": `${item.pdphotoid}`,
          "_explicitType": "com\\projectdocu\\PredicateOperandEQVO"
        }
      });
      return [this.$route.params.id, null , 0,
        {
          "operands": photo_ids,
          "_explicitType": "com\\projectdocu\\PredicateOperatorOrVO"
        },
        [{
          _explicitType: "com\\projectdocu\\OrderSettingVO",
          fieldname: "photodate",
          order: "DESC"
        }]
      ]
    },

    downloadOrPreviewPdf(id , isDownload){
       const modalComponent = this.$refs.downloadPdfModal;
       modalComponent.downloadTasksPdf([id] , isDownload)
    },


    createNewTask () {
      const temp = { selectedtrades: [] }
      this.$store.commit('setTaskPhotos', [])
      this.$store.commit('setTaskEditPhotos', [])
      this.$store.commit('setTaskDetails',temp);
      this.$store.commit('setEditTaskDetails',temp);
      this.$store.commit('toggleTasksDetails', false);
      this.$store.commit('setTasksIsEdit', false)
      this.$router.push({name:'createTask',params:{ id: this.$route.params.id }})
    },

  },
  computed: {
    ...mapState({
      projectUsers: state => state.appSettings.projectUsers,
      detailsPage: state => state.tasks.detailsPage,
      isEdit: state => state.tasks.isEdit,
      default_params: state => state.tasks.default_params,
      selectedTask: state => state.tasks.taskDetails
    }),
  },
  watch: {
    masterCheckbox: function (val){
      if (val){
        this.tasks.forEach(item => {
          if (!this.selectedTasks.includes(item.pdflawid)){
            this.selectedTasks.push(item.pdflawid)
          }
        })
      }else if (val === false){
        this.selectedTasks = []
      }
    },
    checkSelectedRecord: function (){
      let isEvery = this.tasks.every(item => this.selectedTasks.includes(item.pdflawid))
      isEvery ? this.masterCheckbox = true : this.masterCheckbox = null
    }
  }
}
</script>
<style scoped>
.status .fa-circle{
  font-size: 1.2rem !important;
}
.active-tr{
  background: lightgray;
}
input.item-checkbox{
  width: 13px;
  height: 13px;
  cursor: pointer;
}
input.master-checkbox{
  width: 14px;
  height: 14px;
  cursor: pointer;
}
table tbody tr:hover{
  background: lightgray;
}
img.pd-icon{
  cursor: pointer;
}
.btns-bar.position-absolute{
  bottom: 40px;
}
#doctable {
  overflow: hidden;
}
.c-d-delete-icon{
  z-index: 1000;
  visibility: hidden;
  cursor: pointer;
}
table tr:hover td .c-d-delete-icon{
  visibility: visible;
}
table tr td{
  cursor: pointer;
}
.selectionactive {
  padding-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/tasks/TasksList.vue